// src/extenders/before-after-handler.js
var BeforeAfterSlider = class {
  constructor(selector) {
    this.slider = document.querySelector(selector);
    this.handle = this.slider.querySelector("[data-before-slider-handle]");
    this.beforeImage = this.slider.querySelector(".before-after-slider__image--before");
    this.afterImage = this.slider.querySelector(".before-after-slider__image--after");
    this.init();
  }
  init() {
    this.handle.addEventListener("mousedown", this.startDrag.bind(this));
    window.addEventListener("mouseup", this.stopDrag.bind(this));
    window.addEventListener("mousemove", this.drag.bind(this));
    this.handle.addEventListener("touchstart", this.startDrag.bind(this));
    window.addEventListener("touchend", this.stopDrag.bind(this));
    window.addEventListener("touchmove", this.drag.bind(this));
    this.updateClip(this.handle.offsetLeft);
  }
  startDrag(event) {
    this.dragging = true;
    event.preventDefault();
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(event) {
    if (!this.dragging)
      return;
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const rect = this.slider.getBoundingClientRect();
    const x = clientX - rect.left;
    const clampedX = Math.max(0, Math.min(x, rect.width));
    this.handle.style.left = `${clampedX}px`;
    this.updateClip(clampedX);
  }
  updateClip(x) {
    this.afterImage.style.clip = `rect(0, ${x}px, auto, 0)`;
  }
};
document.addEventListener("DOMContentLoaded", () => {
  new BeforeAfterSlider("[data-before-slider]");
});
